import * as React from 'react';
export const coinbasewalletSvg = React.forwardRef(
  function coinbasewalletSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#2C5FF6',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M16 27.2c6.186 0 11.2-5.014 11.2-11.2 0-6.186-5.014-11.2-11.2-11.2C9.814 4.8 4.8 9.814 4.8 16c0 6.186 5.014 11.2 11.2 11.2Zm-2.8-14.857a.857.857 0 0 0-.857.857v5.6c0 .473.384.857.857.857h5.6a.857.857 0 0 0 .857-.857v-5.6a.857.857 0 0 0-.857-.857h-5.6Z',
        fill: '#fff',
      }),
    );
  },
);
coinbasewalletSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var coinbasewallet = {
  category: 'brand',
  colorable: false,
  name: 'coinbasewallet',
  svg: coinbasewalletSvg,
};
